module.exports = __webpack_public_path__ + "media/icons/white-close-b277ce8a.png";